import React from "react";

import MuiTableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { DarkTooltip } from "components/Tooltip";

import { DataTableColumn } from "../../types";

import { ReactComponent as InfoIcon } from "assets/images/info-icon.svg";
import { Stack } from "@mui/material";

interface TableHeadProps<T> {
  columns: DataTableColumn<T>[];
  withActions?: boolean;
}

const TableHead = <T extends { id: string }>(props: TableHeadProps<T>) => {
  const { columns, withActions } = props;

  return (
    <MuiTableHead>
      <TableRow>
        {columns.map(({ field, headerName, headerTooltip, width, align }) => (
          <TableCell
            variant="head"
            key={field}
            sx={{ width }}
            align={align}
            id={field}
          >
            {headerTooltip ? (
              <DarkTooltip arrow title={headerTooltip}>
                <Stack direction="row" alignItems="center">
                  {headerName}
                  <InfoIcon style={{ width: 16, height: 16, marginLeft: 4 }} />
                </Stack>
              </DarkTooltip>
            ) : (
              headerName
            )}
          </TableCell>
        ))}
        {withActions && <TableCell variant="head" />}
      </TableRow>
    </MuiTableHead>
  );
};

export default TableHead;
